/**
 * Per-environment URLs the landing links out to.
 *
 * Read from Vite env vars at build time so staging / prod / regional
 * builds can swap them without code changes (DIT-194 review-2 #3
 * and LOW #14). `.env.example` documents the canonical values.
 */

const stripTrailingSlash = (s: string) => s.replace(/\/+$/, '');

// The fallback is PROD, deliberately. Nothing set this variable until the prod
// deploy existed, so staging ran on the fallback and the fallback was staging —
// which meant the first prod build silently shipped "Log in" buttons pointing at
// dashboard.stage.done-it.app. A visitor would have landed on staging data with
// no visible sign of it. Both pipelines now set the variable explicitly, so this
// value should never be reached; if it ever is again, the failure mode is a
// staging build linking to prod (obvious, harmless) rather than the reverse.
export const DASHBOARD_URL = stripTrailingSlash(
  import.meta.env.VITE_DASHBOARD_URL || 'https://dashboard.done-it.app',
);

export const MARKETING_URL = stripTrailingSlash(
  import.meta.env.VITE_MARKETING_URL || 'https://done-it.app',
);

export const DASHBOARD_LOGIN_URL = `${DASHBOARD_URL}/login`;

/**
 * The consent checkbox links to the documents the visitor is agreeing to.
 *
 * Language-aware, because the pages are prerendered per locale: someone signing
 * up in Polish should land on the Polish page, which tells them the document
 * itself is in English rather than leaving them to work it out. These used to
 * point at the marketing home, since there was no page to point at.
 */
export const termsUrl = (lang: string) => `${MARKETING_URL}/${lang}/legal/terms`;
export const privacyUrl = (lang: string) => `${MARKETING_URL}/${lang}/legal/privacy`;
// TODO(DIT-229): same as above for /tour — the explainer video /
// tour landing isn't published yet.
export const TOUR_URL = MARKETING_URL;
export const CONTACT_EMAIL = 'hello@done-it.app';

// App store links — corrected to the actually published Done-it
// listings (DIT-229 #5). Earlier values pointed at a placeholder
// Apple ID and a wrong Android bundle; both 404'd.
export const APP_STORE_URL =
  'https://apps.apple.com/nl/app/done-it/id6444494390';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=be.done_it.app';
